import { createApi } from "unsplash-js";
import { UnsplashAccessKey } from "../config";

const api = createApi({ accessKey: UnsplashAccessKey });
export const getRandomDolphin = () => api.photos.getRandom({ query: "dolphin" });
